import { NextPageContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import LoginPage from 'templates/Login'
import type { HomeProps } from 'types/pages/home'

export default function Home({ reservationId, checked }: HomeProps) {
  return <LoginPage reservationId={reservationId} checked={checked} />
}

export async function getServerSideProps({ query, locale }: NextPageContext) {
  const reservationId = query.reserva ? String(query.reserva) : ''
  const checked = Boolean(query.check)
  return {
    props: {
      reservationId,
      checked,
      ...(locale && (await serverSideTranslations(locale, ['login'])))
    }
  }
}
